import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import memo from 'memoize-one';

// TODO:(tomo@) All these imports and bad and deeply nested,
//              I know. We will be fixing this over time as
//              we develop this "Discovery Context" to be more
//              generic and not directly linked to category pages
import { SEGMENT_EVENTS, trackUserInteraction } from '../../utils/tracking';
import DiscoveryContext from './context';
import { getSearchParams } from '../../views/CategoryPage/utils/searchParams';
import { defaultSort } from '../../views/CategoryPage/utils/sortOptions';
import { stringifyQS } from '../../utils';
import history from '@/routes/routes/helpers/history';
import {
  getLocationStateForPoint,
  getLocationStateForViewport,
  getLocationStateFromCategoryData as rawGetLocationStateFromCategoryData,
  getSearchParamsFromLocation,
} from '../../views/CategoryPage/provider/location';

const TRACKING_PREFIX = 'category';

const getPathInfo = (router) => {
  if (!router) return;
  const { pathname, search } = router.getCurrentLocation();
  return {
    currentPage: `${pathname}${search}`,
    currentPath: pathname,
  };
};

const getLocationStateFromCategoryData = memo(
  rawGetLocationStateFromCategoryData,
);

// TODO:(tomo@) Convert to a functional component
// TODO:(tomo@) This whole provider is getting reworked
//              in the next set of work. So, sorry about
//              all the hackiness I've added into this.
class DiscoveryProvider extends PureComponent {
  constructor(props) {
    super(props);
    const query = props?.router?.location?.query ?? {};

    this.state = {
      searchParams: {
        selectedPopularDateId: null,
        minDate: null,
        maxDate: null,
        selectedLocation: null,
        geolocation: false,
        locationSearchRadius: null,
        sortOption: defaultSort,
        ...query,
        ...getSearchParams(query),
      },
      data: {},
    };
  }

  setData = (data) => {
    this.setState({ data });
  };

  getSharedTrackingParams = (source, name) => {
    const { router } = this.props;
    const sourceWithPrefix = `${TRACKING_PREFIX}_${source}`;
    return {
      ...getPathInfo(router),
      source: sourceWithPrefix,
      shortName: name,
      name: `${sourceWithPrefix}_${name}`,
    };
  };

  /**
   * Deprecated. Use V2 Provider Update functions.
   */
  updateQs = (categoryData, location, obj) => {
    if (!categoryData || Object.keys(categoryData).length === 0) {
      return;
    }

    const changedLoc = !!location.name || !!obj.selectedLocationName;
    const locCategory = !!(
      categoryData.location.city || categoryData.location.state
    );
    const { searchParams } = this.state;
    let path = this.props.router.location.pathname;
    if (changedLoc && locCategory) {
      const nearestSportCat = categoryData.parents.find(
        (n) => n.type === 'Distance',
      );
      if (nearestSportCat) {
        path = `/${nearestSportCat.path}`;
      }
    }

    const searchString = `?${stringifyQS({
      ...this.state.searchParams,
      ...getSearchParamsFromLocation(location),
      ...obj,
    })}`;

    this.setState(
      {
        searchParams: {
          ...searchParams,
          ...getSearchParamsFromLocation(location),
          ...obj,
        },
      },
      () => {
        history.push({
          pathname: path,
          search: searchString,
        });
      },
    );
  };

  getCurrentPath = (categoryData) => {
    if (categoryData?.type === 'Distance') {
      return categoryData.path;
    }

    return categoryData?.parents?.find((n) => n.type === 'Distance')?.path;
  };

  trackButtonClick = (source) => (buttonName, params = {}) => {
    trackUserInteraction(SEGMENT_EVENTS.BUTTON_CLICKED, {
      ...this.getSharedTrackingParams(source, buttonName),
      ...params,
    });
  };

  trackInputEntered = (source) => (inputName, params = {}) => {
    trackUserInteraction(SEGMENT_EVENTS.INPUT_ENTERED, {
      ...this.getSharedTrackingParams(source, inputName),
      ...params,
    });
  };

  trackMapMoved = (source) => (eventName, params = {}) => {
    trackUserInteraction(SEGMENT_EVENTS.MAP_MOVED, {
      ...this.getSharedTrackingParams(source, eventName),
      ...params,
    });
  };

  trackPanelOpen = (source) => (panelName, params = {}) => {
    trackUserInteraction(SEGMENT_EVENTS.PANEL_OPENED, {
      ...this.getSharedTrackingParams(source, panelName),
      ...params,
    });
  };

  trackPanelClose = (source) => (panelName, params = {}) => {
    trackUserInteraction(SEGMENT_EVENTS.PANEL_CLOSED, {
      ...this.getSharedTrackingParams(source, panelName),
      ...params,
    });
  };

  trackGenericEvent = (source) => (segmentEvent, action, params = {}) => {
    trackUserInteraction(segmentEvent, {
      ...this.getSharedTrackingParams(source, action),
      ...params,
    });
  };

  render() {
    const { searchParams } = this.state;
    const query = this.props?.router?.location?.query ?? {};
    const { name: queryNameParameter, page } = query;
    const categoryData = this.state.data?.categoryData ?? {};
    const sportLabel = categoryData?.labels?.find?.(
      (n) => n.type === 'Distance',
    )?.value;
    const currentPath = this.getCurrentPath(categoryData);

    const updatedSearchParams = {
      ...searchParams,
      ...(page ? { page: parseInt(page, 10) } : {}),
      name: queryNameParameter,
      ...query,
    };

    const parents = categoryData?.parents ?? [];
    const distanceList = categoryData?.sport?.distances ?? [];

    const { location, isLocationSetByUser } = getLocationStateFromCategoryData(
      categoryData,
      query,
    );
    const { name, point, viewport } = location;
    return (
      <DiscoveryContext.Provider
        value={{
          searchParams: updatedSearchParams,
          // TODO(ryan@): Currently, these update search query functions have to take a location
          //              directly passed in. This is because when we currently update the query
          //              in the background, the query string is not updated. This is to prevent
          //              the graphql query from changing, which causes the map to flash when
          //              searching new areas. Therefore, we need to be able to pass new locations
          //              directly in when updating locations. Once this issue is fixed, we can
          //              have a class method that gets the current location, so we won't have to
          //              explicitly pass these in.
          updateSearchQueryStringBackground: (...args) =>
            this.updateQsBackground(location, ...args),
          updateSearchQueryString: (...args) =>
            this.updateQs(categoryData, location, ...args),
          tracking: {
            trackButtonClick: this.trackButtonClick,
            trackInputEntered: this.trackInputEntered,
            trackMapMoved: this.trackMapMoved,
            trackPanelOpen: this.trackPanelOpen,
            trackPanelClose: this.trackPanelClose,
            trackGenericEvent: this.trackGenericEvent,
          },
          location: {
            name,
            point,
            viewport,
            isLocationSetByUser,
            setPoint: (nm, pnt) => {
              const newLocation = getLocationStateForPoint(nm, pnt);

              this.updateQs(categoryData, newLocation);
            },

            setViewport: (nm, vp) => {
              const newLocation = getLocationStateForViewport(nm, vp);

              this.updateQs(categoryData, newLocation);
            },
          },
          parents,
          sportLabel,
          currentPath,
          distanceList,
          currentQs: query,
          setData: this.setData,
        }}
      >
        {this.props.children}
      </DiscoveryContext.Provider>
    );
  }
}

export default withRouter(DiscoveryProvider);
